<template>
  <el-cascader
    style="width: 100%"
    v-bind="$props"
    :options="options"
    :props="props"
    @input="handleInput">
    <span slot-scope="{ node }">
      <span class="el-icon-space">{{ node.label }}</span>
    </span>
  </el-cascader>
</template>

<script>
  import {buildTree, getTreeRoot} from "@/assets/utils";

  export default {
    name: "RoleCascader",
    props: {
      value: {},
      filterable: Boolean,
      clearable: Boolean,
      placeholder: String,
    },
    data() {
      return {
        props: {
          key: 'code',
          parentKey: 'pcode',
          label: 'name',
          value: 'code',
          children: 'children',
          rootValue: '',
          expandTrigger: 'hover',
          checkStrictly: true,
        },
      }
    },
    computed: {
      roles() {
        return this.$store.state.options.roles;
      },
      treeRoot() {
        return getTreeRoot(this.roles, this.props)
      },
      options() {
        return buildTree(this.roles, this.props, this.treeRoot)
      }
    },
    methods: {
      handleInput(val) {
        this.$emit('input', val);
      }
    },
    created() {
      this.$store.commit('initRoles')
    }
  }
</script>

<style scoped>
</style>
